import { render, staticRenderFns } from "./doc7.vue?vue&type=template&id=1b46fe21"
import script from "./doc7.vue?vue&type=script&lang=js"
export * from "./doc7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports